/**
 * Dropdown options for a list filter, built from the ROWS THEMSELVES rather
 * than from the store the references point into.
 *
 * The locations store holds every settlement in the country and the clubs
 * store every club in the federation; offering all of them as filter values
 * makes a list that is mostly dead ends, where all but a handful of choices
 * empty the table. Only values some row actually carries can narrow anything.
 *
 * Titles are resolved from `titles` (the store) when it has the row, because
 * a nested reference may carry a stale title — or none at all — while the
 * store holds the one the table itself is rendering.
 *
 * @param {Array}    rows   the unfiltered list being filtered
 * @param {Function} pick   row → the reference ({id, title?}), null, or a list
 *                          of them (an athlete's rank in each discipline)
 * @param {Array}    titles the store to resolve ids against
 * @returns {Array} `{id, title}`, unique, sorted by title
 */
/**
 * Alphabetical as a person reads a list (30 Oct 2026: «покажуй міста … по
 * алфавіту»): by the Ukrainian alphabet, case aside, and quotes and brackets
 * aside — «СК 'Легіон'» reads «СК Легіон», «[DEMO] Клуб» reads «DEMO Клуб».
 * Stripped here rather than by `ignorePunctuation`, which a Node built
 * without full ICU ignores.
 */
const sortKey = title => String(title).replace(/[^\p{L}\p{N}\s]/gu, '').replace(/\s+/g, ' ').trim();

export const byTitle = (a, b) => sortKey(a.title).localeCompare(sortKey(b.title), 'uk', { sensitivity: 'base', numeric: true });

const referenceOptions = (rows = [], pick, titles = []) => {
    const seen = new Map();

    rows.forEach(row => {
        [].concat(pick(row) || []).forEach(ref => {
            if (!ref || seen.has(ref.id)) {
                return;
            }
            const item = (titles || []).find(i => i.id === ref.id);
            seen.set(ref.id, (item && item.title) || ref.title || String(ref.id));
        });
    });

    return Array.from(seen, ([id, title]) => ({ id, title }))
        .sort(byTitle);
};

export default referenceOptions;
